import { jsxs, jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { TextInput } from "./TextInput.js";
import { useClassNamePrefix } from "../../../auxiliary/useClassNamePrefix.js";
const SlugInput = memo(
  forwardRef(({ prefix, link, overlay, onOverlayClick, ...textInputProps }, ref) => {
    const componentClassName = `${useClassNamePrefix()}slug-input`;
    return /* @__PURE__ */ jsxs("div", { className: `${componentClassName}`, children: [
      prefix && /* @__PURE__ */ jsx("div", { className: `${componentClassName}-prefix`, children: link ? /* @__PURE__ */ jsx("a", { href: link, className: `${componentClassName}-prefix-link`, target: "_blank", rel: "noopener noreferrer", children: prefix }) : prefix }),
      /* @__PURE__ */ jsxs("div", { className: `${componentClassName}-input`, children: [
        /* @__PURE__ */ jsx(TextInput, { ...textInputProps, distinction: prefix ? "seamless" : textInputProps.distinction, ref }),
        overlay || onOverlayClick ? /* @__PURE__ */ jsx("div", { className: `${componentClassName}-overlay`, onClick: onOverlayClick, children: overlay }) : null
      ] })
    ] });
  })
);
export {
  SlugInput
};
//# sourceMappingURL=SlugInput.js.map
